import { StateT } from "../../../store";
import { ActivityReduxT } from "./activityReducers";

export const getActivity = ({ activity }: StateT): ActivityReduxT => activity;
